<div class="client-link-not-found" data-testid="client-view-not-found">
  <div class="client-link-not-found__container">
    <div class="client-link-not-found__icon">
      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
          fill="#f44336"
          opacity="0.3"
        />
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#f44336" />
      </svg>
    </div>

    <div class="client-link-not-found__content">
      <h1 class="client-link-not-found__title">Link Unavailable</h1>
      <p class="client-link-not-found__message">This link may be invalid or expired. Please contact your coach.</p>
    </div>

    <div class="client-link-not-found__actions">
      <p class="client-link-not-found__help">Need help? Reach out to your coach for a new assessment link.</p>
    </div>
  </div>
</div>
